function faleConoscoSidebar() {
  const btnFaleConosco = document.querySelector('.btn-fale-conosco');
  const sidebar = document.querySelector('.fale-conosco-sidebar');
  const overlay = document.querySelector('.fale-conosco-overlay');
  const btnClose = document.querySelector('.fale-conosco-close');

  if (!btnFaleConosco || !sidebar || btnFaleConosco.dataset.faleConoscoReady === 'true') return;

  function openSidebar() {
    sidebar.classList.add('active');
    if (overlay) {
      overlay.classList.add('active');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    sidebar.classList.remove('active');
    if (overlay) {
      overlay.classList.remove('active');
    }
    document.body.style.overflow = '';
  }

  window.openFaleConoscoSidebar = openSidebar;
  window.closeFaleConoscoSidebar = closeSidebar;

  btnFaleConosco.dataset.faleConoscoReady = 'true';

  btnFaleConosco.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    openSidebar();
  });

  if (btnClose) {
    btnClose.addEventListener('click', closeSidebar);
  }

  if (overlay) {
    overlay.addEventListener('click', closeSidebar);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sidebar.classList.contains('active')) {
      closeSidebar();
    }
  });
}

try {
  isReady("categorias", faleConoscoSidebar);
} catch (error) {}

document.addEventListener('DOMContentLoaded', faleConoscoSidebar);
window.addEventListener('load', faleConoscoSidebar);

setTimeout(faleConoscoSidebar, 300);
setTimeout(faleConoscoSidebar, 1000);

function sincronizarWhatsappFaleConosco() {
  return;
}

try {
  isReady("categorias", sincronizarWhatsappFaleConosco);
} catch (error) {}

document.addEventListener('DOMContentLoaded', sincronizarWhatsappFaleConosco);
window.addEventListener('load', sincronizarWhatsappFaleConosco);
setTimeout(sincronizarWhatsappFaleConosco, 300);
setTimeout(sincronizarWhatsappFaleConosco, 1000);

function renomearContatoParaFaleConosco() {
  const links = document.querySelectorAll('.fale-conosco-links-secondary li a');
  links.forEach(function(link) {
    var titulo = link.getAttribute('title') || '';
    var texto = link.textContent.trim();

    /* Contato -> Fale conosco */
    if (titulo === 'Contato' || texto === 'Contato') {
      link.childNodes.forEach(function(node) {
        if (node.nodeType === 3 && node.textContent.trim() === 'Contato') {
          node.textContent = 'Fale conosco';
        }
      });
      if (titulo === 'Contato') {
        link.setAttribute('title', 'Fale conosco');
      }
    }

    /* Política de Entrega e Frete -> Entrega e frete */
    if (titulo.indexOf('Entrega e Frete') !== -1 || texto.indexOf('Entrega e Frete') !== -1 || link.getAttribute('href') === '/politica-de-entrega-e-frete') {
      link.childNodes.forEach(function(node) {
        if (node.nodeType === 3 && node.textContent.trim().length > 0) {
          node.textContent = 'Entrega e frete';
        }
      });
      link.setAttribute('title', 'Entrega e frete');
    }
  });
}

try {
  isReady("categorias", renomearContatoParaFaleConosco);
} catch (error) {}

document.addEventListener('DOMContentLoaded', renomearContatoParaFaleConosco);
window.addEventListener('load', renomearContatoParaFaleConosco);
setTimeout(renomearContatoParaFaleConosco, 300);
setTimeout(renomearContatoParaFaleConosco, 1000);

function adicionarSVGsFaleConosco() {
  const itens = document.querySelectorAll('.fale-conosco-links-secondary li a');

  const svgs = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
  <path id="Caminho_40950" data-name="Caminho 40950" d="M976,6470v-9.8a4.987,4.987,0,0,0-.218-2.11,2.018,2.018,0,0,0-.874-.87,4.923,4.923,0,0,0-2.108-.22h-7.6a4.923,4.923,0,0,0-2.108.22,2.018,2.018,0,0,0-.874.87,4.987,4.987,0,0,0-.218,2.11v6.6a4.987,4.987,0,0,0,.218,2.11,2.018,2.018,0,0,0,.874.87,4.923,4.923,0,0,0,2.108.22Zm0,0h4.4a2.466,2.466,0,0,0,1.054-.11.971.971,0,0,0,.437-.44,2.454,2.454,0,0,0,.109-1.05v-2.74a2.133,2.133,0,0,0-.028-.48,1.042,1.042,0,0,0-.119-.29,2.093,2.093,0,0,0-.322-.36l-2.062-2.06a2.152,2.152,0,0,0-.361-.32.785.785,0,0,0-.289-.12,1.986,1.986,0,0,0-.482-.03H976m-7,10.5a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,969,6472.5Zm11,0a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,980,6472.5Z" transform="translate(-961 -6456)" fill="none" stroke="#34343e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
</svg>`,

    `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
  <path id="Caminho_40951" data-name="Caminho 40951" d="M424.5,5680.67a2.33,2.33,0,0,0,2.333,2.33H429a2.5,2.5,0,0,0,0-5h-2a2.5,2.5,0,0,1,0-5h2.167a2.33,2.33,0,0,1,2.333,2.33m-3.5-3.83v1.5m0,10v1.5m10-6.5a10,10,0,1,1-10-10A10,10,0,0,1,438,5678Z" transform="translate(-417 -5667)" fill="none" stroke="#34343e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
</svg>`,

    `<svg xmlns="http://www.w3.org/2000/svg" width="18.828" height="20.829" viewBox="0 0 18.828 20.829">
  <path id="Caminho_40949" data-name="Caminho 40949" d="M2252,1519h-16m0,0,4-4m-4,4,4,4m-4-14h16m0,0-4-4m4,4-4,4" transform="translate(-2234.586 -1503.586)" fill="none" stroke="#34343e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
</svg>`,

    `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="21.803" viewBox="0 0 18 21.803">
  <path id="Caminho_40948" data-name="Caminho 40948" d="M3513,4197.5l2,2,4.5-4.5m4.5,3c0,4.91-5.35,8.48-7.3,9.61a1.474,1.474,0,0,1-.49.23.982.982,0,0,1-.42,0,1.474,1.474,0,0,1-.49-.23c-1.95-1.13-7.3-4.7-7.3-9.61v-4.78a4.65,4.65,0,0,1,.13-1.55,1.952,1.952,0,0,1,.55-.78,4.285,4.285,0,0,1,1.4-.67l5.36-2.01a1.651,1.651,0,0,1,.42-.13.659.659,0,0,1,.28,0,1.651,1.651,0,0,1,.42.13l5.36,2.01a4.285,4.285,0,0,1,1.4.67,1.952,1.952,0,0,1,.55.78,4.65,4.65,0,0,1,.13,1.55Z" transform="translate(-3507 -4187.064)" fill="none" stroke="#34343e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
</svg>`
  ];

  itens.forEach((li, index) => {
    if (svgs[index]) {
      li.insertAdjacentHTML('afterbegin', svgs[index]);
    }
  });
}

try {
  isReady("categorias", adicionarSVGsFaleConosco);
} catch (error) {}

function updateNameCategory() {
  const category = document.querySelector(
    ".nav-header #departamento-allCats-menu .nav-menu-hiperlink"
  );

  if (!category) return;

  category.innerHTML = `
    <span data-wsjs-icon="">
      <svg ico="Grid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.5 11.5">
			<g data-name="burguer Menu">
				<path data-name="Caminho 8756" d="M18.75 1.5h-18a.75.75 0 0 1 0-1.5h18a.75.75 0 0 1 0 1.5Z"></path>
				<path data-name="Caminho 8757" d="M18.75 6.5h-18a.75.75 0 0 1 0-1.5h18a.75.75 0 0 1 0 1.5Z"></path>
				<path data-name="Caminho 8758" d="M18.75 11.5h-18a.75.75 0 0 1 0-1.5h18a.75.75 0 0 1 0 1.5Z"></path>
			</g>
		</svg>
    </span>
    Mais categorias
    `;
}

try {
  isReady("categorias", updateNameCategory);
} catch (error) {}
